import React from 'react';
import { Checkbox, FormControlLabel, FormGroup, SxProps } from '@mui/material';

interface CheckboxItemProps {
  id: string;
  label: string;
  disabled?: boolean;
  checked: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps;
}

const CheckboxItem = ({ id, label, disabled, checked, handleChange, sx }: CheckboxItemProps) => {
  return (
    <FormGroup sx={sx}>
      <FormControlLabel control={<Checkbox checked={checked} id={id} onChange={handleChange} />} label={label} disabled={disabled} />
    </FormGroup>
  );
};

export default CheckboxItem;
